import { useLang } from 'hooks/lang';

import { Button, IconButton, Modal, Column, Row } from 'components/Blocks';

import { EyeIcon } from 'components/Icons';

import { useToggleV2 } from 'hooks';

import { truncateText } from 'utils/text';

interface JustificationProps {
  children?: never;
  value: string;
}

const TABLE_LIMIT = 75;

export function Justification({ value }: JustificationProps) {
  const { t } = useLang();
  const [isOpen, openHandlers] = useToggleV2();

  if (value.length < TABLE_LIMIT) return <>{value}</>;

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={openHandlers.turnOff}
        title={t('justification') as string}
        width="min(80vw, 540px)"
      >
        <Column justifyContent="center">
          <p className="text-justify">{value}</p>

          <Button onClick={openHandlers.turnOff}>{t('close')}</Button>
        </Column>
      </Modal>

      <Row>
        <>{truncateText(value, TABLE_LIMIT)}</>

        <IconButton onClick={openHandlers.turnOn} size="small">
          <EyeIcon />
        </IconButton>
      </Row>
    </>
  );
}
